export default "__VITE_ASSET__D55MWN49__"